/**
 * @param {string} boxHeading
 * @param {string} bootstrapSize
 * @param {function} clickHandler
 */

import ArrowBig from "../../icons/arrowBig";

function BigOptionBox(props) {
  if (props.clickHandler === undefined) {
    return null;
  }


  return (
    <li className="book-meeting__card">
        <button
          className="book-meeting__button"
          aria-label={props.boxHeading}
          onClick={() => {
            props.clickHandler();
          }}
          tabIndex="0"
        >
          <div className="book-meeting__label">{props.boxHeading}</div>
          <ArrowBig></ArrowBig>
        </button>
    </li>
  );
}

export default BigOptionBox;
